<h2 mat-dialog-title>
    {{ tableName ? ('Ecommerce.POS.update_table_title' | transloco) : ('Ecommerce.POS.new_table_tile' | transloco) }}
</h2>
<div mat-dialog-content>
    <mat-form-field class="full-width">
        <mat-label>{{ 'Ecommerce.POS.table_name' | transloco }}</mat-label>
        <input matInput [(ngModel)]="tableName"/>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onCancel()">{{ 'cancel' | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        [disabled]="!tableName"
        (click)="onSave()">
        {{ 'save' | transloco }}
    </button>
</div>
